import * as type from './types';

export function getCurrentProject(data) {
    return {
        type: type.GET_CURRENT_PROJECT_DATA_REQUESTED,
        data: data,
    }
}